import React from 'react';
import { translate } from 'react-i18next';

import SharedCalendarRecipient from 'components/account/SharedCalendarRecipient.js';

class ExistingCalendarShares extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      recipients: [],
    };
  }

  extractRecipients(shareData, userEmail) {
    const recipients = [];
    _.each(shareData, (share) => {
      if (share.email != userEmail) {
        recipients.push(share);
      }
    });
    return recipients;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      recipients: this.extractRecipients(nextProps.shareData, nextProps.user.email),
    });
  }

  render() {
    const recipientRows = this.state.recipients.map(
      recipient => <SharedCalendarRecipient key={_.uniqueId()} recipient={recipient} />,
      this,
    );

    return (
      <div className="sharedCalendarEditor">
        <p>{this.props.t('ExistingCalendarShares.shared_emails')}</p>
        {recipientRows}
      </div>
    );
  }
}

export default translate()(ExistingCalendarShares);
